package io.horion.cv.models

import io.horion.cv.components.forms.ConclusionForm
import io.horion.cv.components.forms.ContentForm
import io.horion.cv.components.forms.DestinataireDetailsForm
import io.horion.cv.components.forms.MotivationForm
import io.horion.cv.components.forms.PersonalFormWithoutDetails
import io.horion.cv.components.forms.PieceJointeAccordionContent
import io.horion.cv.components.forms.SituationForm


val reaccordionSections = listOf(
    AccordionSection(
        id = "personal_info",
        title = "Informations personnelles",
        content = {PersonalFormWithoutDetails()}
    ),
    AccordionSection(
        id = "destinataire",
        title = "Destinataire",
        content = {DestinataireDetailsForm() }
    ),
    AccordionSection(
        id = "introduction",
        title = "Introduction",
        content = {ContentForm()}
    ) ,
    AccordionSection(
        id = "situation",
        title = "Situation",
        content = {SituationForm()}
    ),
    AccordionSection(
        id = "motivation",
        title = "Motivation",
        content = {MotivationForm()}
    ),
    AccordionSection(
        id = "conclusion",
        title = "Conclusion",
        content = {ConclusionForm()}
    ),
    AccordionSection(
        id = "piece_jointe",
        title = "Pieces Jointes",
        content = {
        PieceJointeAccordionContent(
                onComplete = { },
                onAddCompetenceAndClose = { }
            )
        }
    )
)

